import { Content } from '@builder.io/sdk-react';

import { PageModel, BuilderContent } from '~/src/common/services/Builder/types';

import { BUILDER_COMPONENTS } from './constants';

type Props = {
  model: PageModel;
  content: Nullable<BuilderContent>;
};

const PageContent = ({ model, content }: Props) => {
  return (
    <Content
      model={model}
      content={content}
      apiKey={process.env.NEXT_PUBLIC_BUILDER_API_KEY}
      customComponents={BUILDER_COMPONENTS}
    />
  );
};

export { PageContent };
